import React from 'react';

import { observer } from 'mobx-react';
import { Button, Alert, InfoBox } from '@infoods/lifebase-ui';

import classes from './CurrentPlanWidget.module.scss';

import { TitledInfo } from '../../../../shared/components/ui-components';
import { TitleRow } from './TitleRow/TitleRow';
import { PriceInfo } from '../../../components/PriceInfo/PriceInfo';
import { scanIqCurrentSubscriptionPlanStore } from '../../../stores/scanIqCurrentSubscriptionPlanStore';
import { getFlagsObject } from '../../../../shared/utils/sortingAndGroupingUtil';
import { BILLING_PERIOD_TYPE } from '../../../constants/billingPeriodType';
import { isFuture } from '../../../../shared/utils/dateUtils';
import { dateFormat } from '../../../../shared/constants/apiDateFormat';
import { SubscriptionCancelAlert } from './SubscriptionCancelAlert/SubscriptionCancelAlert';
import { openConfirmationModal } from '../../../../shared/features/confirmation';

const CurrentPlanWidget = observer(() => {
  const { currentSubscriptionPlan, paymentStatusFlag, cancelSubscription } =
    scanIqCurrentSubscriptionPlanStore;

  if (!currentSubscriptionPlan) {
    return null;
  }

  const { subscription, lastTransaction } = currentSubscriptionPlan;

  const billingPeriodTypeFlags = getFlagsObject(BILLING_PERIOD_TYPE, [
    subscription?.billingPeriodType,
  ]);

  const prices = {
    price: subscription?.monthlyRenewalPrice,
    finalPrice: subscription?.monthlyRenewalPriceFinal,
  };

  const isHaveActivePeriod =
    lastTransaction.setupNewSubscriptionDate &&
    isFuture(lastTransaction.setupNewSubscriptionDate, dateFormat);

  const cancelledButStillActive = paymentStatusFlag.CANCELED && isHaveActivePeriod;

  const handleCancelSubscription = async () => {
    const title = `Are you sure you want to cancel ${subscription?.name}?`;
    const text =
      'Upon canceling, the user will still have access to scan for the time they paid for with the subscription.';

    openConfirmationModal({
      title,
      text,
      confirmBtnConfig: { text: 'Confirm', onClick: cancelSubscription },
    });
  };

  return (
    <InfoBox title="Current Plan">
      <div className={classes.container}>
        <TitleRow />
        <div className={classes.paymentInfoRow}>
          <TitledInfo title="Initial payment">
            <PriceInfo
              {...(billingPeriodTypeFlags.DAILY && prices)}
              duration="per scan"
            />
          </TitledInfo>
          <TitledInfo title="Auto Renew">
            <PriceInfo
              {...(billingPeriodTypeFlags.MONTHLY && prices)}
              duration="per month"
            />
          </TitledInfo>
        </div>
        <div>
          {billingPeriodTypeFlags.DAILY && (
            <Alert severity="info" size="small">
              Service available until the end of today
            </Alert>
          )}
          {billingPeriodTypeFlags.MONTHLY && cancelledButStillActive && (
            <SubscriptionCancelAlert
              setupNewSubscriptionDate={lastTransaction.setupNewSubscriptionDate}
            />
          )}
          {billingPeriodTypeFlags.MONTHLY && !paymentStatusFlag.CANCELED && (
            <Button variant="outlined" size="small" onClick={handleCancelSubscription}>
              Cancel subscription
            </Button>
          )}
        </div>
      </div>
    </InfoBox>
  );
});

export { CurrentPlanWidget };
